import { render, staticRenderFns } from "./TemplateCategoriesBaseForm.vue?vue&type=template&id=d6013fb4&"
import script from "./TemplateCategoriesBaseForm.vue?vue&type=script&lang=js&"
export * from "./TemplateCategoriesBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports